import React from 'react';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import QuillRichTextEditor from '../common/QuillRichTextEditor';

const useStyles = makeStyles(() => ({
  templates: {
    height: '60vh',
    width: '97%',
    background: '#f3f4f7',
    padding: '15px 10px',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    overflowY: 'auto',
  },
  inputField: {
    width: '90%',
    padding: '15px 10px',
    borderRadius: '5px',
    border: '1px solid gray',
    outline: 'none',
    marginTop: '5px',
    background: 'transparent',
  },

  required_field: {
    color: '#667085',
    '&:after': {
      content: "' *'",
      color: '#F50000',
    },
  },
}));

export default function TemplateForm({
  formName,
  setFormName,
  formSummary,
  setFormSummary,
  formOutline,
  setFormOutline,
}) {
  const classes = useStyles();

  const handleTempForm = (e) => {
    const title = e.target.value;
    if (title.length <= 25) {
      setFormName(title);
    }
  };

  return (
    <Grid className={classes.templates}>
      <Grid>
        <Typography className={classes.required_field}>Template Name (limit: 25 characters)</Typography>
        <input
          placeholder="ex: EV Roadtrip"
          className={classes.inputField}
          value={formName}
          onChange={handleTempForm}
        />
      </Grid>
      <Grid>
        <Typography className={classes.required_field}>Template Summary </Typography>
        <textarea
          className={classes.inputField}
          style={{ resize: 'vertical', fontFamily: 'sans-serif' }}
          value={formSummary}
          onChange={(e) => setFormSummary(e.target.value)}
        />
      </Grid>
      <Grid>
        <Typography className={classes.required_field}>Outline</Typography>
        <Grid item>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid item style={{ width: '94%' }}>
              <QuillRichTextEditor value={formOutline} changeFn={(e) => setFormOutline(e)} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
